import Vue from 'vue'
import Renderer from './Renderer.vue'
import { createStore } from './store';

if(process.env.NODE_ENV === 'production') {
    Vue.config.devtools = false
    Vue.config.debug = false
    Vue.config.silent = true
} else {
    Vue.config.devtools = true
    Vue.config.debug = true
    Vue.config.silent = false
}

export const render = (rootId, state = {}) => {
    const store = createStore(state);
    const instance = new Vue({
        el: rootId,
        store,
        template: '<Renderer/>',
        components: { Renderer }
    });

    return {
        instance,
        store,
    }
};
